import React, { FC } from 'react';
import styled from '@emotion/styled';
import Heading from '~ComponentsImproved/Typography/Heading';
import { useMetadata } from '~Hooks';

const Statusbar = styled.div`
  height: 24px;
  width: 100vw;
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  background-color: var(--colorBlueGray1300);
  position: fixed;
  left: 0;
  top: 0;
`;

/** Displays the venue name top-center with space to show date & time from the system */
const DeviceStatusbar: FC = () => {
  const metadata = useMetadata();

  return (
    <Statusbar>
      <Heading level={6} color={'var(--colorBlueGray600)'}>
        {metadata.data.venueName}
      </Heading>
    </Statusbar>
  );
};

export default DeviceStatusbar;
